import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ClientUtilities } from '../../../utils/client-utils';


@Component({
    selector: 'networking-vc',
    styles: [require('./networking-view.scss')],
    template: require('./networking-view.html')
})
export default class NetworkingView {
    private active: string = 'nav-link active';
    private inactive: string = 'nav-link';
    private networkClassNames: string = '';
    private gatewayClassNames: string = '';
    private isVsphereClient = false;

    onNetworkSelected(event) {
        this.router.navigate(['services/networking/network']);
        this.networkClassNames = this.active;
        this.gatewayClassNames = this.inactive;

    }

    onGatewaySelected(event) {
        this.router.navigate(['services/networking/gateways']);
        this.networkClassNames = this.inactive;
        this.gatewayClassNames = this.active;
    }

    constructor(private router: Router) {
    }

    ngOnInit() {
        let url = document.createElement('a');
        url.href = window.location.href;
        let path: string = url.hash; // this gives #/services/networking/*
        let pathParams: string[] = path.split('/');
        let networkingIndex = -1;
        for (let i = 0; i < pathParams.length; i++) {
            if (pathParams[i] === 'networking') {
                networkingIndex = i;
                break;
            }
        }

        let activateNetworks: boolean = true;

        if (networkingIndex !== -1) {
            if (networkingIndex === (pathParams.length - 1)) {

                // This case indicates that the module is initialized when url is /services/networking

                this.router.navigate(['services/networking/' + 'network']);
                activateNetworks = true;

            } else if (networkingIndex === (pathParams.length - 2 ) || networkingIndex === (pathParams.length - 4 )) {

                // This case indicates that the module is initialized when url is /services/networking/(network/gateways)
                // or /services/networking/(network/gateways)/edit/<id>

                let lastPath = pathParams[networkingIndex + 1];
                activateNetworks = (lastPath === 'network');
                this.router.navigate(['services/networking/' + lastPath]);

            } else if (networkingIndex === (pathParams.length - 3)) {

                // This case indicates that the module is initialized when url is
                // /services/networking/(network/gateways)/new

                let lastPath = pathParams[networkingIndex + 1];
                activateNetworks = (lastPath === 'network');
                this.router.navigate(['services/networking/' + lastPath + '/new']);
            }
        }

        if (activateNetworks) {
            this.networkClassNames = this.active;
            this.gatewayClassNames = this.inactive;
        } else {
            this.networkClassNames = this.inactive;
            this.gatewayClassNames = this.active;
        }

        this.isVsphereClient = ClientUtilities.runningInPluginUI();

    }

    getNetworkClassNames() {
        if (this.isNetworkUrl()) {
            return this.active
        }
        return this.inactive;
    }
    getGatewayClassNames() {
        if (this.isNetworkUrl()) {
            return this.inactive
        }
        return this.active;
    }

    isNetworkUrl() {
        let url = document.createElement('a');
        url.href = window.location.href;
        let path: string = url.hash;
        if (path.indexOf('networking/network') >= 0) {
            return true;
        }
        return false;
    }
};




// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networking-view.component.ts